var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-app",
        [
          _c("my-asidebar", { attrs: { "active-tab": "district" } }),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "dashboard-area" },
            [
              _c("top-bar"),
              _vm._v(" "),
              _c("div", { staticClass: "dashboard-content-wrap" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "dashboard-bread dashboard--bread dashboard-bread-2",
                  },
                  [
                    _c("div", { staticClass: "container-fluid" }, [
                      _c("div", { staticClass: "row align-items-center" }, [
                        _c("div", { staticClass: "col-lg-6" }, [
                          _c("div", { staticClass: "breadcrumb-content" }, [
                            _c("div", { staticClass: "section-heading" }, [
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "sec__title font-size-30 text-white",
                                },
                                [_vm._v("District")]
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-6" }, [
                          _c(
                            "div",
                            { staticClass: "breadcrumb-list text-right" },
                            [
                              _c("ul", { staticClass: "list-items" }, [
                                _c("li", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-white",
                                      attrs: { href: _vm.basePath },
                                    },
                                    [_vm._v("Anasayfa")]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", [_vm._v("İlçe")]),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-item p-3" },
                  [
                    _c("v-data-table", {
                      staticClass: "elevation-1",
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.districtList,
                        "items-per-page": 5,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "top",
                          fn: function () {
                            return [
                              _c(
                                "v-toolbar",
                                { attrs: { flat: "" } },
                                [
                                  _c("v-toolbar-title", [_vm._v("İlçeler")]),
                                  _vm._v(" "),
                                  _c("v-divider", {
                                    staticClass: "mx-4",
                                    attrs: { inset: "", vertical: "" },
                                  }),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-dialog",
                                    {
                                      attrs: { "max-width": "500px" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        color: "primary",
                                                        dark: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.editedItem =
                                                            Object.assign(
                                                              {},
                                                              _vm.defaultItem
                                                            )
                                                        },
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "la la-plus mr-1",
                                                  }),
                                                  _vm._v(
                                                    "\n                        Yeni İlçe Yarat\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                      model: {
                                        value: _vm.dialog,
                                        callback: function ($$v) {
                                          _vm.dialog = $$v
                                        },
                                        expression: "dialog",
                                      },
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        [
                                          _c("v-card-title", [
                                            _c(
                                              "span",
                                              { staticClass: "text-h5" },
                                              [_vm._v(_vm._s(_vm.formTitle))]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "v-container",
                                                [
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                            md: "4",
                                                          },
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              label: "İlçe Adı",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.editedItem
                                                                  .name,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.editedItem,
                                                                    "name",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "editedItem.name",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("v-autocomplete", {
                                                            attrs: {
                                                              filter:
                                                                _vm.filterCities,
                                                              items:
                                                                _vm.cityList,
                                                              label: "Şehir",
                                                              flat: "",
                                                              "hide-no-data":
                                                                "",
                                                              "hide-details":
                                                                "",
                                                              "item-value":
                                                                "id",
                                                              placeholder:
                                                                "Şehir",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "selection",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var item =
                                                                      ref.item
                                                                    var selected =
                                                                      ref.selected
                                                                    return [
                                                                      _vm._v(
                                                                        "\n                                  " +
                                                                          _vm._s(
                                                                            item.name
                                                                          ) +
                                                                          "\n                                "
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                                {
                                                                  key: "item",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var item =
                                                                      ref.item
                                                                    var tile =
                                                                      ref.tile
                                                                    return [
                                                                      _c(
                                                                        "v-list-tile-content",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                    " +
                                                                              _vm._s(
                                                                                item.name
                                                                              ) +
                                                                              "\n                                  "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ]
                                                            ),
                                                            model: {
                                                              value:
                                                                _vm.editedItem
                                                                  .cityId,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.editedItem,
                                                                    "cityId",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "editedItem.cityId",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              label: "Code 2",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.editedItem
                                                                  .code2,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.editedItem,
                                                                    "code2",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "editedItem.code2",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              label: "Code 3",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.editedItem
                                                                  .code3,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.editedItem,
                                                                    "code3",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "editedItem.code3",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-actions",
                                            [
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "blue darken-1",
                                                    text: "",
                                                  },
                                                  on: { click: _vm.close },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          Cancel\n                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "blue darken-1",
                                                    text: "",
                                                  },
                                                  on: { click: _vm.save },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          Save\n                        "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "item.name",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("tr", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.name) +
                                    "\n                "
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.cityId",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("tr", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.getCityName(item.cityId)) +
                                    "\n                "
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.actions",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "table-content mr-2",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteItem(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "theme-btn theme-btn-small",
                                      },
                                      [_c("i", { staticClass: "la la-trash" })]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "table-content",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editItem(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "theme-btn theme-btn-small",
                                      },
                                      [_c("i", { staticClass: "la la-edit" })]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }